import { render, staticRenderFns } from "./CheckboxConfiguratorWrapper.vue?vue&type=template&id=da55cb36"
import script from "./CheckboxConfiguratorWrapper.vue?vue&type=script&lang=js"
export * from "./CheckboxConfiguratorWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports